import { ApiResponse } from 'types/api';

import { apiRequest } from 'services/api/client';

export type Plan = {
  id: number;
  name: string;
  price: string;
  is_active: boolean;
  description: string | null;
};

export const plansService = {
  getPlans() {
    return apiRequest<ApiResponse<Plan[]>>('/plans');
  },
};
